import React,{useState,useEffect} from "react";
import { Modal,Card, Row, Steps, Typography, Table, Col, Divider, Button, Input, message } from "antd";

import { useSelector } from 'react-redux'
import { Footer } from "antd/lib/layout/layout";
import { ArrowDownOutlined, ArrowLeftOutlined } from "@ant-design/icons";
import moment from "moment"
import OrderService from "../../services/OrderService";



const { Title } = Typography;
const Circle = () => {
    return (
      <svg
      width="30"
      height="31"
      viewBox="0 0 30 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15 30.1807C23.2843 30.1807 30 23.4245 30 15.0904C30 6.75618 23.2843 0 15 0C6.71573 0 0 6.75618 0 15.0904C0 23.4245 6.71573 30.1807 15 30.1807ZM14.9998 22.2375C18.9239 22.2375 22.1051 19.0372 22.1051 15.0895C22.1051 11.1417 18.9239 7.94141 14.9998 7.94141C11.0757 7.94141 7.89453 11.1417 7.89453 15.0895C7.89453 19.0372 11.0757 22.2375 14.9998 22.2375Z"
        fill="#3A3A3A"
        fill-opacity="0.7"
      />
      </svg>
    )
  }
export default function CateringOrderDetail({order,setShowDetails}) {
  
  const [isQuantityNull, setIsQuantityNull] = useState()
 
useEffect(()=>{
  setIsQuantityNull(order?.catering_request_items?.some(item=>item.quantity == null || !item.quantity))
},[])

  const sendInvoice = async(type)=>{
     const cateringItems = order?.catering_request_items?.map(item=>{
      return {
         id: item.id,
         quantity: item.quantity,
      }
     })
     let data={}
     const requestPayload = {catering_request_items:cateringItems}
     if(type === "invoice")
       data = await OrderService.sendCustomerInvoice(order?.id,requestPayload)
  else
     data =  await OrderService.sendCustomerReview(order?.id,requestPayload)

     if(data?.msg)
    message.success(data.msg)
  }
 

    return (
        <div>
             <div className="catering-header">
        <Title level={4} style={{cursor:"pointer"}}
        onClick={()=>setShowDetails(false)}> <ArrowLeftOutlined/> Order no - {order?.order? order?.order?.order_num : order?.id}</Title>
      </div>

      <div style={{ marginTop: 40 }}>
        <Card bordered={false} className="card-order-container" onClick={()=>{
          
        }}>
         <div className="cat-each-section">
            <div className="cat-section-title">CUSTOMER DETAILS</div>
            <Row className="row-cat-section">
                <Col>
                <div className="cat-details-name">
                <div className="cat-title">Name:</div>
                <div className="cat-name">{order?.customer?.name}</div>
                </div>
                <div className="cat-details-name">
                <div className="cat-title">Email:</div>
                <div className="cat-name">{order?.customer?.email}</div>
                </div>
                </Col>
                <Col>
                <div className="cat-details-name">
                <div className="cat-title">Phone:</div>
                <div className="cat-name">{order?.customer?.phone_number}</div>
                </div></Col>
                
            </Row>
         </div>
         {order?.order && <>
         <Divider/>
         <div className="cat-each-section">
            <div className="cat-section-title">ORDER DETAILS</div>
            <Row className="row-cat-section">
                <Col>
                <div className="cat-details-name">
                <div className="cat-title">Order Id:</div>
                <div className="cat-name">{order?.order?.id}</div>
                </div>
                <div className="cat-details-name">
                <div className="cat-title">Branch:</div>
                <div className="cat-name">{order?.restaurant?.name}</div>
                </div>
                </Col>
                <Col>
                <div className="cat-details-name">
                <div className="cat-title">Payment Id:</div>
                <div className="cat-name">{order?.order?.payment_id}</div>
                </div>
                <div className="cat-details-name">
                <div className="cat-title">Payment Provider Id:</div>
                <div className="cat-name">{order?.order?.payment_provider_id}</div>
                </div>
                </Col>
                
            </Row>
         </div>
         </>}
         <Divider/>

         <div className="cat-each-section">
            <div className="cat-section-title">EVENT DETAILS</div>
            <Row className="row-cat-section">
                <Col>
                <div className="cat-details-name">
                <div className="cat-title">Event Type:</div>
                <div className="cat-name">{order?.event_type}</div>
                </div>
                <div className="cat-details-name">
                <div className="cat-title">Event Address:</div>
                <div className="cat-name">{order?.customer_location?.address_field1 + ", "+ 
                order?.customer_location?.address_field2 }</div>
                </div>

                <div className="cat-details-name">
                <div className="cat-title">Event Details:</div>
                <div className="cat-name">{order?.event_details}</div>
                </div>

                <div className="cat-details-name">
                <div className="cat-title">Date & Time:</div>
                <div className="cat-name">
                {moment(order?.event_time).format("MM/DD/yyyy h:mm:ss a")}
                  </div>
                </div>
                <div className="cat-details-name">
                <div className="cat-title">Guest Count:</div>
                <div className="cat-name">{order?.guest_count ? order?.guest_count : "---"}</div>
                </div>
                </Col>
                
                
            </Row>
         </div>
         <Divider/>

         <div className="cat-each-section">
            <div className="cat-section-title">NOTES</div>
            <Row className="row-cat-section">
                <Col>
                <div className="cat-details-name">
                {/* <div className="cat-title">Location Notes:</div> */}
                <div className="cat-name">{order?.description}</div>
                </div>
                {/* <div className="cat-details-name">
                <div className="cat-title">General Notes:</div>
                <div className="cat-name">raseem@mail.com</div>
                </div> */}

                
                </Col>
            
                
            </Row>
         </div>
         <Divider/>

         <div className="cat-each-section">
            <div className="cat-section-title">STATUS</div>
            <Row className="row-cat-section">
            <Col span={24} >
              <Steps
                labelPlacement="vertical"
                current={order?.status_history.find(item=>item.current_status == "FULFILLED") ? 2 :
                order?.status_history.find(item=>item.current_status == "READY") ? 1: 0}
                items={[
                  {
                    title: "Accepted",
                    icon: <Circle />,
                  },
                  {
                    title: "Completed",
                    icon: <Circle />,
                  },
                  {
                    title: "Delivered",
                    icon: <Circle />,
                  },
                ]}
              />
            </Col>
                
                
            </Row>
         </div>
         <Divider/>


         <div className="cat-each-section">
            <div className="cat-section-title">SUMMARY</div>
            <div style={{width:"100%"}}>
            {order?.catering_request_items?.map(item=>
            <Row className="row-cat-section" style={{justifyContent:"space-between",marginBottom:"20px"}}>
                <Col style={{display:"flex"}}>
                {isQuantityNull?
                  <div className="input-quantity-edit">
                  <Input/> X
                  </div>
                 
                 :
                 <div>{item?.quantity} X </div> 
                 
                }
                <div className="cat-details-desc">
                <div style={{marginLeft:"10px",fontWeight:600}}>{item?.menu_item?.name}</div>
                <div style={{marginLeft:"10px",opacity: 0.5, marginTop:"5px"}}>{item?.menu_item?.description}</div>
                </div>
                </Col>
                 
                <Col style={{marginRight:"50px",fontWeight:600}}>
                
               ${item?.menu_item?.price}
                </Col>
            </Row>
            
            )}
            </div>
         </div>
         <Divider/>
<div className="customer-invoice">
  {isQuantityNull?
  <>

                <Button
                    type="primary"
                    ghost
                    style={{
                      display: "block",
                      width: 180,
                      marginTop: 20,
                      marginRight: 20
                    }}
                  >
                    Cancel
                  </Button>
                  <Button
                    type="primary"
                    // ghost
                    style={{
                      display: "block",
                      width: 180,
                      marginTop: 20,
                    }}
                    onClick={()=>sendInvoice("review")}
                  >
                    Send for Review
                  </Button>  
                </>
                :
                 <>
                 <Button
                    type="primary"
                    ghost
                    style={{
                      display: "block",
                      width: 180,
                      marginTop: 20,
                    }}
                    onClick={()=>sendInvoice("invoice")}
                  >
                    Customer Invoice
                  </Button>
                  
                </>
}
</div>
        
            </Card>
            </div>
        </div>
       
    );
  }





